import MarkedDownContent from "./MarkedDownContent";

export default MarkedDownContent;
